export default "/9c6714386325a098bd7aac95e76b1803.svg";